<template lang="pug">
  section.drawer(v-if="data")

    DrawerCover(:model="data")
    DrawerSampleList(:samples="samples")
    DrawerFooter(:numItems="samples.length", v-if="samples")

</template>

<script>

import Vue from 'vue'
import SampleModel from '@/models/SampleModel'
import DrawerModel from '@/models/DrawerModel'
import DrawerFooter from '@/components/DrawerFooter'
import DrawerPreview from '@/components/DrawerPreview'
import DrawerCover from '@/components/DrawerCover'
import DrawerSampleList from '@/components/DrawerSampleList'
import * as TYPE from '@/const.types'
import i18n from "@/i18n";

export default {
  name: 'drawer',
  props: ['uuid'],
  components: {
    DrawerFooter,
    DrawerPreview,
    DrawerCover,
    DrawerSampleList
  },
  data () {
    return {
      data: null,
      samples: null
    }
  },
  watch: {
    // Action lorsque l'uuid change
    // c'est à dire que l'on change de route
    uuid (newUuid, oldUuid) {
      this.loadData()
    }
  },
  beforeRouteEnter () {
    let argsArray = Array.from(arguments);
    argsArray.unshift(i18n.locale);
    Vue.$api.entityGuard.apply(this, argsArray)
  },
  beforeRouteUpdate () {
    let argsArray = Array.from(arguments);
    argsArray.unshift(i18n.locale);
    Vue.$api.entityGuard.apply(this, argsArray)
  },
  methods: {
    loadData () {
      this.$api.getDrawer(this.$i18n.locale, this.uuid)
        .then(response => {
          this.data = new DrawerModel(response.data)
          this.loadSamples()
        })
    },
    loadSamples () {
      const types = [TYPE.SAMPLE_FOSSIL, TYPE.SAMPLE_ORE, TYPE.SAMPLE_MINERAL, TYPE.SAMPLE_ROCK]
      let promises = types.map((type) => {
        return this.$api.getDrawerSamples(this.$i18n.locale, type, this.uuid)
          .then(response => {
            const samples = response.data.data.map((s) => {
              return new SampleModel(s, response.data.included)
            })
            return samples
          })
      })
      Promise.all(promises).then((results) => {
        this.samples = results.reduce((pre, cur) => {
          return pre.concat(cur)
        })
      })
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>
